import React from 'react'
import PropTypes from 'prop-types'

import { Checkbox, LightTooltip } from './../../default'
import { Collapse, FormControlLabel, FormGroup, Grid, Paper, Typography, withStyles } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';

function FormCheckbox({ classes, id, label, children, renderField, info, fkProps, ...rest }) {
  const Comp = children ? Paper : <div></div>

  return (
    <Comp>
      <Grid container alignItems='center'>
        <Grid item xs={12}>
          <FormGroup className={classes.root}>
            <FormControlLabel control={
              <Checkbox
                id={id}
                checked={fkProps.values[id]}
                onChange={(event) => {
                  fkProps.setFieldValue(id, event.target.checked)
                }}
                onBlur={() => fkProps.setTouched({ ...fkProps.touched, [id]: true })}
                {...rest}
              />
            }
              label={
                <div>
                  {label}
                  {
                    info &&
                    <LightTooltip
                      title={
                        <Typography>
                          {info}
                        </Typography>
                      }
                      placement='top-end'
                      arrow>
                      <InfoOutlined fontSize='small' color='primary' />
                    </LightTooltip>
                  }
                </div>
              } />
          </FormGroup>
        </Grid>
        {
          children &&
          <Grid item xs={12}>
            <Collapse in={fkProps.values[id]} className={classes.collapse}>
              {
                children.map((child, index) => renderField(child, fkProps, index))
              }
            </Collapse>
          </Grid>
        }
      </Grid>
    </Comp>
  )
}

FormCheckbox.propsTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

FormCheckbox.defaultProps = {
  optionKey: 'name'
}

const styles = theme => ({
  root: {
    marginLeft: theme.spacing(2)
  },
  collapse: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
})

export default withStyles(styles)(FormCheckbox)